export default __webpack_public_path__ + "static/media/mainImg.a52493c4.jpg";